import { writable } from 'svelte/store';
import type { ConnectionStatus } from './WebSocket';
import type { IPublicSession } from './server/models';

export const session = writable<IPublicSession | null>(null);

export const clearSession = () => {
  session.set(null);
};

export const socketStatus = writable<ConnectionStatus>('NOT_CONNECTED');

export const timeZone = writable<string | undefined>(undefined);
